import { Component, OnInit, ViewChild, ElementRef, NgZone, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmService } from 'src/app/services/confirm.service';
import { ConfirmOptions } from 'src/app/types/confirm-types';
import { ClarityModule, ClrModalModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ClrModalModule, CommonModule, ClarityModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent implements OnInit {
  private confirmService = inject(ConfirmService);
  private zone = inject(NgZone);

  open = false;
  options!: ConfirmOptions;
  private result$!: Subject<boolean>;

  icon?: string;
  iconClass = '';
  buttonClass = '';
  @ViewChild('cancelBtn') cancelButton!: ElementRef<HTMLButtonElement>;

  ngOnInit(): void {
    this.confirmService.confirmState$.subscribe(state => {
      this.options = state.options;
      this.result$ = state.result$;
      this.setType(state.options.type!);
      this.open = true;

      this.zone.onStable
        .asObservable()
        .pipe(take(1))
        .subscribe(() => {
          this.cancelButton?.nativeElement.focus();
        });
    });
  }

  private setType(type: string): void {
    switch (type) {
      case 'danger':
        this.icon = 'exclamation-circle';
        this.iconClass = 'icon-danger';
        this.buttonClass = 'btn-danger';
        break;

      case 'warning':
        this.icon = 'exclamation-triangle';
        this.iconClass = 'icon-warning';
        this.buttonClass = 'btn-warning';
        break;

      default:
        this.icon = 'info-circle';
        this.iconClass = 'icon-info';
        this.buttonClass = 'btn-primary';
    }
  }

  ok(): void {
    this.result$.next(true);
    this.result$.complete();
    this.open = false;
  }

  cancel(): void {
    this.result$.next(false);
    this.result$.complete();
    this.open = false;
  }
}
